import Head from 'next/head'
import SubmitForm from '@/components/SubmitForm'

export default function Contact() {
  return (
    <>
      <Head>
        <title>Kontakt | Autoverwertungs Deutschland</title>
        <meta name="description" content="Kontaktieren Sie uns für Fragen zur Autoverwertung, KFZ-Ankauf oder Fahrzeugentsorgung. Wir helfen Ihnen gerne weiter!" />
        <meta property="og:title" content="Kontakt | Autoverwertung Deutschland" />
        <meta property="og:description" content="Kontaktieren Sie uns für Fragen zur Autoverwertung, KFZ-Ankauf oder Fahrzeugentsorgung. Wir helfen Ihnen gerne weiter!" />
        <meta property="og:image" content="/images/cars/reccar.webp" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://autoverwertungs.de/contact" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Kontakt | Autoverwertung Deutschland" />
        <meta name="twitter:description" content="Kontaktieren Sie uns für Fragen zur Autoverwertung, KFZ-Ankauf oder Fahrzeugentsorgung. Wir helfen Ihnen gerne weiter!" />
        <meta name="twitter:image" content="/logo.jpeg" />
        <meta name="robots" content="index, follow" />
      </Head>
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold">Kontakt</h1>
        <p className="mt-4">Schreiben Sie uns eine Nachricht oder nutzen Sie das Formular.</p>
        <div className="mt-6">
          <SubmitForm />
        </div>

      </div>
    </>
  )
}
